import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/23e00e1c-a573-4dca-a1a5-183a71c5d8aa";
export const REGISTER_URL = "https://a.ntrk2.com/1e15cb07-713a-4c47-b429-5110509a6b6c";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://winfastbd.loadprkw2a.com/download?openExternalBrowser=1&id=f2uhfoi6m8h7uu9";

export * from "./codes";
export * from "./context";
